import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const Experience = () => {
  const experienceContainerRef = useRef(null);
  const experienceEntriesRef = useRef([]);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: experienceContainerRef.current,
        start: 'top 80%',
        toggleActions: 'play none none reverse',
      },
    });

    tl.from(experienceContainerRef.current, { opacity: 0, y: 50, duration: 1, ease: 'power2.out' });

    experienceEntriesRef.current.forEach((entry, index) => {
      tl.from(
        entry,
        {
          opacity: 0,
          y: -20,
          duration: 0.6,
          delay: index * 0.2,
          ease: 'power1.out',
        },
        '-=0.4'
      );
    });
  }, []);

  return (
    <div
      ref={experienceContainerRef}
      className="sm:px-8 sm:h-screen"
    >
      <h1 className='text-[8vw] lg:text-5xl font-bold mb-24 text-[#FFDC00] relative'>
        experience
        <span className='absolute -bottom-4 left-0 w-full h-0.5 bg-gradient-to-r from-[#FFDC00] to-transparent '></span>
      </h1>

      <div className="space-y-12">
        {[
          {
            role: 'FrontEnd Developer',
            company: 'Abaris Softech Pvt Ltd., New Delhi',
            dates: '4/2024 - 7/2025',
            details: [
              'Design, develop, and maintain scalable full-stack web applications',
              'Lead the end-to-end development of 3D interactive websites using modern web technologies to enhance digital presence and engagement',
              'Collaborate with cross-functional teams including design, product, and QA to deliver projects on time and according to specifications',
              'Optimize backend systems using Node.js, Express, and databases like MongoDB to support high-traffic applications',
            ],
          },
        ].map((exp, index) => (
          <div
            ref={(el) => (experienceEntriesRef.current[index] = el)}
            key={index}
            className="transform -translate-y-10"
          >
            <h3 className="text-sm sm:leading-8 leading-6 md:text-[1.8vw] font-semibold mb-2 text-white">
              {exp.role}<i className="text-[#FFDC00] ri-guide-line mx-3"></i>{exp.company}
            </h3>
            <p className="text-gray-400 mb-10 mt-3 sm:text-[1vw] text-[2vw]">{exp.dates}</p>
            <ul className="list-disc pl-5 text-gray-300 sm:text-[1vw] text-[2vw]">
              {exp.details.map((item, idx) => (
                <li key={idx} className="mb-6">{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;